import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    updateInitializedEventId,
    openEventContextMenu,
    closeEventContextMenu,
} from '../actions/calendarEventContextMenuStoreActions';

mutator(openEventContextMenu, actionMessage => {
    const { sourceId, viewState } = actionMessage;
    getStore().sourceId = sourceId;
    getStore().viewState = viewState;
});

mutator(updateInitializedEventId, actionMessage => {
    getStore().initializedEventId = actionMessage.itemId;
});

mutator(closeEventContextMenu, () => {
    getStore().initializedEventId = null;
    getStore().viewState = {
        itemId: null,
        parentFolderId: '',
        clickEvent: null,
    };
});
